var render = function render(){var _vm=this,_c=_vm._self._c;return _c('switcher',{attrs:{"status":_vm.delete_filter_status,"activeColor":"bg-red-500","title":_vm.DELETE_TITLE},on:{"on-switch":_vm.setDeleteFilterStatus}})
}
var staticRenderFns = []

export { render, staticRenderFns }